export const scope = 'boilerplate.components.Errors';

const messages:any = {
    BAD_REQUEST: `${scope}.BAD_REQUEST`,
    CONSTRAINT_VIOLATION: `${scope}.CONSTRAINT_VIOLATION`,
    DATA_EXIST: `${scope}.DATA_EXIST`,
    ERR_BAD_RESPONSE: `${scope}.ERR_BAD_RESPONSE`,
    DEFAULT_ERROR: `${scope}.DEFAULT_ERROR`,
    DTO_SENT_FAILED_VALIDATION: `${scope}.DTO_SENT_FAILED_VALIDATION`,
    ERR_CONFLICT: `${scope}.ERR_CONFLICT`,
    NOT_FOUND: `${scope}.NOT_FOUND`,
    PERSON_SAME_EMAIL_ALREADY_EXISTED: `${scope}.PERSON_SAME_EMAIL_ALREADY_EXISTED`,
    RDV_NOT_FOUND: `${scope}.RDV_NOT_FOUND`,
    RDV_DATE_NOT_FREE: `${scope}.RDV_DATE_NOT_FREE`,
    SERVICE_AVAILABLE_ONLY_FOR_PRESET_APPOINTMENT: `${scope}.SERVICE_AVAILABLE_ONLY_FOR_PRESET_APPOINTMENT`,
    UNIQUE_CONSTRAINT: `${scope}.UNIQUE_CONSTRAINT`,
    ACTIVATE_ACCOUNT_EXCEPTION: `${scope}.ACTIVATE_ACCOUNT_EXCEPTION`,
    ACCOUNT_DISABLED: `${scope}.ACCOUNT_DISABLED`,
    ACCOUNT_EXPIRED: `${scope}.ACCOUNT_EXPIRED`,
    ACCOUNT_LOCKED: `${scope}.ACCOUNT_LOCKED`,
    BAD_CREDENTIALS: `${scope}.BAD_CREDENTIALS`,
    CREDENTIALS_EXPIRED: `${scope}.CREDENTIALS_EXPIRED`,
    DATA_EXCEPTION: `${scope}.DATA_EXCEPTION`,
    DATA_LOCKED: `${scope}.DATA_LOCKED`,
    DEADLINE_EXCEEDED: `${scope}.DEADLINE_EXCEEDED`,
    FORBIDEN_ACCESS: `${scope}.FORBIDEN_ACCESS`,
    GONE_EXCEPTION: `${scope}.GONE_EXCEPTION`,
    ILLEGAL_ARGUMENT: `${scope}.ILLEGAL_ARGUMENT`,
    NUMBER_CHOICE_EXCEEDED: `${scope}.NUMBER_CHOICE_EXCEEDED`,
    CANCELED: `${scope}.CANCELED`,
    CLOSE: `${scope}.CLOSE`,
    STORAGE_EXCEPTION: `${scope}.STORAGE_EXCEPTION`,
    PERMISSION_EXCEPTION: `${scope}.PERMISSION_EXCEPTION`,
    PERSON_ALREADY_EXIST_EXCEPTION: `${scope}.PERSON_ALREADY_EXIST_EXCEPTION`,
    PARENT_ALREADY_EXIST_EXCEPTION: `${scope}.PARENT_ALREADY_EXIST_EXCEPTION`,
    REQUEST_TIMEOUT: `${scope}.REQUEST_TIMEOUT`,
    SERVICE_UNAVAILABLE: `${scope}.SERVICE_UNAVAILABLE`,
    SIZE_EXCEPTION: `${scope}.SIZE_EXCEPTION`,
    SQL_EXCEPTION: `${scope}.SQL_EXCEPTION`,
    UNSUPPORTED_MEDIA_TYPE: `${scope}.UNSUPPORTED_MEDIA_TYPE`,
    USERNAME_NOTFOUND: `${scope}.USERNAME_NOTFOUND`,
    ONLY_SUSPENDED_ACCOUNT_COULD_BE_ACTIVATE: `${scope}.ONLY_SUSPENDED_ACCOUNT_COULD_BE_ACTIVATE`,
    PERSON_NOT_FOUND: `${scope}.PERSON_NOT_FOUND`,
    CET_EMPLOYER_NA_PAS_DE_FONCTION: `${scope}.CET_EMPLOYER_NA_PAS_DE_FONCTION`,
    EMPLOYEE_WITH_SAME_EMAIL_EXIST: `${scope}.EMPLOYEE_WITH_SAME_EMAIL_EXIST`,
    PARENT_SAVED_FAILED: `${scope}.PARENT_SAVED_FAILED`,
    VERSEMENT_EFFECTUE_POUR_CET_ENFANT_SUPPRESSION_EMPECHEE: `${scope}.VERSEMENT_EFFECTUE_POUR_CET_ENFANT_SUPPRESSION_EMPECHEE`,
    VERSEMENT_NOT_FOUND: `${scope}.VERSEMENT_NOT_FOUND`,
    ENFANT_NOT_FOUND: `${scope}.ENFANT_NOT_FOUND`,
    DELETE_NOT_PERMIT_FOR_THIS_APPOINTMENT: `${scope}.DELETE_NOT_PERMIT_FOR_THIS_APPOINTMENT`,
    COMPTE_EMPLOYER_DESACTIVER: `${scope}.COMPTE_EMPLOYER_DESACTIVER`,
    FONCTION_OF_EMPLOYEE_NOT_FOUND: `${scope}.FONCTION_OF_EMPLOYEE_NOT_FOUND`,
    RDV_IS_CANCELED: `${scope}.RDV_IS_CANCELED`,
    // ---- Appointment / RDV (ims_v3 appointment module) ----
    RDV_PARENT_DATE_NOT_FREE: `${scope}.RDV_PARENT_DATE_NOT_FREE`,
    RDV_EMPLOYEE_DATE_NOT_FREE: `${scope}.RDV_EMPLOYEE_DATE_NOT_FREE`,
    DELETE_NOT_PERMIT_YOU_ARE_NOT_OWNER: `${scope}.DELETE_NOT_PERMIT_YOU_ARE_NOT_OWNER`,
    PARENT_NOT_REPLY_YET: `${scope}.PARENT_NOT_REPLY_YET`,
    EMPLOYEE_NOT_REPLY_YET: `${scope}.EMPLOYEE_NOT_REPLY_YET`,
    CONFIRM_STATUS_WITH_DATES_MEETING_NOT_EQUAL: `${scope}.CONFIRM_STATUS_WITH_DATES_MEETING_NOT_EQUAL`,
    CANCEL_NOT_PERMIT_FOR_THIS_PARENT: `${scope}.CANCEL_NOT_PERMIT_FOR_THIS_PARENT`,
    RDV_CANCELED_EDITION_LOCKED: `${scope}.RDV_CANCELED_EDITION_LOCKED`,
    ENFANT_ID_NOT_DEFINED_IN_CRENO_ENFANTPARENT: `${scope}.ENFANT_ID_NOT_DEFINED_IN_CRENO_ENFANTPARENT`,
    CLASSE_ID_NOT_DEFINED_IN_CRENO_ENFANTPARENT: `${scope}.CLASSE_ID_NOT_DEFINED_IN_CRENO_ENFANTPARENT`,
    PARENT_ID_NOT_DEFINED: `${scope}.PARENT_ID_NOT_DEFINED`,
    PARENT_ID_NOT_DEFINED_IN_CRENO_ENFANTPARENT: `${scope}.PARENT_ID_NOT_DEFINED_IN_CRENO_ENFANTPARENT`,
    CRENEAU_NOT_DEFINED: `${scope}.CRENEAU_NOT_DEFINED`,
    CRENEAU_ENFANTPARENT_NOT_DEFINED: `${scope}.CRENEAU_ENFANTPARENT_NOT_DEFINED`,
    CRENEAU_EMPLOYEE_NOT_DEFINED: `${scope}.CRENEAU_EMPLOYEE_NOT_DEFINED`,
    CRENEAU_MUST_NOT_EMPTY: `${scope}.CRENEAU_MUST_NOT_EMPTY`,
    PARENT_CHOICE_NOT_FOUND: `${scope}.PARENT_CHOICE_NOT_FOUND`,
    PARENT_NOT_OWN_THIS_CHOICE: `${scope}.PARENT_NOT_OWN_THIS_CHOICE`,
    CRENEAU_ENFANT_PARENT_NOT_FOUND: `${scope}.CRENEAU_ENFANT_PARENT_NOT_FOUND`,
    ENFANT_PARENT_ID_NOT_SETTED: `${scope}.ENFANT_PARENT_ID_NOT_SETTED`,
    ILLEGAL_STATUS_ONLY_CANCEL_AND_CONFIRM_ACCEPTED: `${scope}.ILLEGAL_STATUS_ONLY_CANCEL_AND_CONFIRM_ACCEPTED`,
    ILLEGAL_ID_VALUE_ONLY_POSITIVE_VALUE_ACCEPTED: `${scope}.ILLEGAL_ID_VALUE_ONLY_POSITIVE_VALUE_ACCEPTED`,
    CRENEAURDV_ID_NOT_MATCHED: `${scope}.CRENEAURDV_ID_NOT_MATCHED`,
    MEETING_TYPE_NOT_DEFINED: `${scope}.MEETING_TYPE_NOT_DEFINED`,
    ENFANT_PARENT_NOT_FOUND: `${scope}.ENFANT_PARENT_NOT_FOUND`,
    ACTION_NOT_ALLOWED: `${scope}.ACTION_NOT_ALLOWED`,
    PRESET_CHOICE_EXCEEDED: `${scope}.PRESET_CHOICE_EXCEEDED`,
    // ---- Appointment / RDV (admin transitions & slot assignment) ----
    ADMIN_ROLE_REQUIRED: `${scope}.ADMIN_ROLE_REQUIRED`,
    APPOINTMENT_ALREADY_CANCELED: `${scope}.APPOINTMENT_ALREADY_CANCELED`,
    APPOINTMENT_ALREADY_PAST: `${scope}.APPOINTMENT_ALREADY_PAST`,
    FILL_COMMENT_TO_EXPLAIN_APPOINTMENT_REPORT: `${scope}.FILL_COMMENT_TO_EXPLAIN_APPOINTMENT_REPORT`,
    FILL_COMMENT_TO_EXPLAIN_APPOINTMENT_CANCELED: `${scope}.FILL_COMMENT_TO_EXPLAIN_APPOINTMENT_CANCELED`,
    PARENT_ALREADY_CHOSE: `${scope}.PARENT_ALREADY_CHOSE`,
    // ---- Library loans (LivreEmprunt) ----
    EMPRUNT_ID_MUST_BE_NOT_NULL: `${scope}.EMPRUNT_ID_MUST_BE_NOT_NULL`,
    EMPRUNT_ID_MUST_BE_NULL: `${scope}.EMPRUNT_ID_MUST_BE_NULL`,
    DATE_EMPRUNT_MUST_BE_NOT_NULL: `${scope}.DATE_EMPRUNT_MUST_BE_NOT_NULL`,
    DATE_RETOUR_MUST_BE_NOT_NULL: `${scope}.DATE_RETOUR_MUST_BE_NOT_NULL`,
    DATE_DEADLINE_RETOUR_MUST_BE_NOT_NULL: `${scope}.DATE_DEADLINE_RETOUR_MUST_BE_NOT_NULL`,
    NOT_ENOUGH_BOOK_IN_STORE: `${scope}.NOT_ENOUGH_BOOK_IN_STORE`,
    BOOK_ALREADY_LOAN: `${scope}.BOOK_ALREADY_LOAN`,
    BOOK_ALREADY_LOANED_BY_YOU: `${scope}.BOOK_ALREADY_LOANED_BY_YOU`,
    LIVRE_NOT_FOUND: `${scope}.LIVRE_NOT_FOUND`,
    LOAN_NOT_FOUND: `${scope}.LOAN_NOT_FOUND`,
    BOOK_IS_LOAN_AND_CANNOT_BE_DELETED: `${scope}.BOOK_IS_LOAN_AND_CANNOT_BE_DELETED`,

    // ---- Account, session & authentication (gateway-server / core-service) ----
    ACCOUNT_JWT_TOKEN_EXPIRED: `${scope}.ACCOUNT_JWT_TOKEN_EXPIRED`,
    DATA_NULL: `${scope}.DATA_NULL`,
    DATA_POSITIVE_NUMBER: `${scope}.DATA_POSITIVE_NUMBER`,
    // Aliases onto existing friendly texts (the backend codeMessage differs
    // slightly from the human-readable token we registered earlier).
    ACTIVATE_JWT_ACCOUNT_EXCEPTION: `${scope}.ACTIVATE_ACCOUNT_EXCEPTION`,
    ACCOUNT_JWT_DISABLED: `${scope}.ACCOUNT_DISABLED`,
    ACCOUNT_JWT_EXPIRED: `${scope}.ACCOUNT_EXPIRED`,
    ACCOUNT_JWT_LOCKED: `${scope}.ACCOUNT_LOCKED`,
    CREDENTIALS_JWT_EXPIRED: `${scope}.CREDENTIALS_EXPIRED`,
    USERNAME_NOT_FOUND: `${scope}.USERNAME_NOTFOUND`,

    // ---- User account management ----
    USERNAME_ALREADY_EXISTS: `${scope}.USERNAME_ALREADY_EXISTS`,
    UNABLE_TO_GENERATE_USERNAME: `${scope}.UNABLE_TO_GENERATE_USERNAME`,
    LE_NOUVEAU_MOT_DE_PASSE_EST_INVALIDE: `${scope}.LE_NOUVEAU_MOT_DE_PASSE_EST_INVALIDE`,
    LE_NOUVEAU_USERNAME_EST_INVALIDE: `${scope}.LE_NOUVEAU_USERNAME_EST_INVALIDE`,
    LE_USERNAME_EST_INVALIDE: `${scope}.LE_USERNAME_EST_INVALIDE`,
    NO_AUTHENTICATED_USER: `${scope}.NO_AUTHENTICATED_USER`,
    USER_IDS_EMPTY: `${scope}.USER_IDS_EMPTY`,

    // ---- Not found: parent / teacher / product / appointment slot / group ----
    PARENT_NOT_FOUND: `${scope}.PARENT_NOT_FOUND`,
    TEACHER_NOT_FOUND: `${scope}.TEACHER_NOT_FOUND`,
    PRODUIT_NOT_FOUND: `${scope}.PRODUIT_NOT_FOUND`,
    CRENEAU_EMPLOYEE_NOT_FOUND: `${scope}.CRENEAU_EMPLOYEE_NOT_FOUND`,
    CRENEAU_ENFANTPARENT_NOT_FOUND: `${scope}.CRENEAU_ENFANT_PARENT_NOT_FOUND`,
    ENFANT_ID_MUST_BE_NOT_NULL: `${scope}.ENFANT_ID_MUST_BE_NOT_NULL`,
    GROUP_OF_ENFANT_NOT_FOUND: `${scope}.GROUP_OF_ENFANT_NOT_FOUND`,
    THIS_PARENT_IS_NOT_RDV_ACTOR: `${scope}.THIS_PARENT_IS_NOT_RDV_ACTOR`,

    // ---- Scolarité / fees / payment plans / mini-club ----
    ENFANT_DEJA_INSCRIT: `${scope}.ENFANT_DEJA_INSCRIT`,
    INSCRIPTION_ID_NOT_NULL: `${scope}.INSCRIPTION_ID_NOT_NULL`,
    INSCRIPTION_ID_IS_NULL: `${scope}.INSCRIPTION_ID_IS_NULL`,
    ECHEANCIER_ENFANT_LIER_A_UN_VERSEMENT: `${scope}.ECHEANCIER_ENFANT_LIER_A_UN_VERSEMENT`,
    PROTEGER_CONTRE_LA_SUPPRESSION: `${scope}.PROTEGER_CONTRE_LA_SUPPRESSION`,
    PROTEGER_CONTRE_LA_SUPPRESSSION: `${scope}.PROTEGER_CONTRE_LA_SUPPRESSSION`,
    LE_FRAIS_EST_UTILISE_DANS_UN_FRAIS_PONCTUEL: `${scope}.LE_FRAIS_EST_UTILISE_DANS_UN_FRAIS_PONCTUEL`,
    LE_FRAIS_EST_UTILISE_DANS_UN_VERSEMENT: `${scope}.LE_FRAIS_EST_UTILISE_DANS_UN_VERSEMENT`,
    LE_FRAIS_IS_USED_AS_ECHEANCIER: `${scope}.LE_FRAIS_IS_USED_AS_ECHEANCIER`,
    LE_FRAIS_IS_USED_AS_FRAIS_ONE_SHOT: `${scope}.LE_FRAIS_IS_USED_AS_FRAIS_ONE_SHOT`,
    LE_GROUPENFANT_EST_UTILISE_DANS_UN_VERSEMENT: `${scope}.LE_GROUPENFANT_EST_UTILISE_DANS_UN_VERSEMENT`,
    LE_GROUP_EST_UTILISE_DANS_UN_VERSEMENT: `${scope}.LE_GROUP_EST_UTILISE_DANS_UN_VERSEMENT`,
    LE_MINICLUB_EST_UTILISE_DANS_UN_VERSEMENT: `${scope}.LE_MINICLUB_EST_UTILISE_DANS_UN_VERSEMENT`,
    ONLY_FRAIS_AVEC_ECHEANCES_SONT_ACCEPTES: `${scope}.ONLY_FRAIS_AVEC_ECHEANCES_SONT_ACCEPTES`,
    PAIEMENT_CODE_IS_EMPTY: `${scope}.PAIEMENT_CODE_IS_EMPTY`,
    DATE_MODE_PAIEMENT_IS_EMPTY: `${scope}.DATE_MODE_PAIEMENT_IS_EMPTY`,
    VENTE_ID_NOT_NULL: `${scope}.VENTE_ID_NOT_NULL`,

    // ---- Products & stock ----
    NOT_ENOUGH_PRODUCT_IN_STORE: `${scope}.NOT_ENOUGH_PRODUCT_IN_STORE`,

    // ---- Messaging / discussion threads ----
    SPACE_NOT_FOUND: `${scope}.SPACE_NOT_FOUND`,
    SPACE_ID_NOT_DEFINED: `${scope}.SPACE_ID_NOT_DEFINED`,
    SPACE_CLOSE: `${scope}.SPACE_CLOSE`,
    SPACE_CLOSE_PERMISSION_NOT_ALLOWED: `${scope}.SPACE_CLOSE_PERMISSION_NOT_ALLOWED`,
    SPACE_DELETE_PERMISSION_NOT_ALLOWED: `${scope}.SPACE_DELETE_PERMISSION_NOT_ALLOWED`,

    // ---- Surveys (sondages) ----
    SONDAGE_IS_CLOSED: `${scope}.SONDAGE_IS_CLOSED`,
    NO_RESPONSE_FOUND_FOR_THIS_SONDAGE: `${scope}.NO_RESPONSE_FOUND_FOR_THIS_SONDAGE`,

    // ---- Planning (IMS day) ----
    IMS_DAY_ID_INVALID: `${scope}.IMS_DAY_ID_INVALID`,
    IMS_DAY_NOT_FOUND: `${scope}.IMS_DAY_NOT_FOUND`,

    ERR_NETWORK: `${scope}.ERR_NETWORK`,
}
export default messages;